<template>
  <!-- Top Nav -->
  <div
    id="topOfPage"
    class="border-b border-b-white/10 bg-primary"
  >
    <div
      class="mx-auto container-padding max-w-7xl py-1.5 flex justify-between items-center gap-4 text-white text-[13px] font-medium"
    >
      <div class="flex items-center gap-1 xs:gap-3 w-full">
        <AppDropdown
          v-if="authStore.user?.isAdmin"
          class="nav-top-dropdown"
          trigger-text="Admin"
          content-width="w-24"
        >
          <AppDropdownItem :to="{ name: 'app_admin_event_list' }">
            Events
          </AppDropdownItem>

          <AppDropdownItem :to="{ name: 'app_admin_device_list' }">
            Devices
          </AppDropdownItem>

          <AppDropdownItem :to="{ name: 'app_admin_price_list' }">
            Prices
          </AppDropdownItem>

          <AppDropdownItem :to="{ name: 'app_admin_order_list' }">
            Orders
          </AppDropdownItem>

          <AppDropdownItem :to="{ name: 'app_admin_sales_report' }">
            Sales Report
          </AppDropdownItem>
        </AppDropdown>

        <ul class="hidden sm:inline-flex list-none gap-4">
          <li
            v-for="(link, index) in menuLinks"
            :key="index"
          >
            <AppLink
              class="!text-[13px] !font-medium hover:text-[#aac7e4]"
              :to="link.to"
            >
              {{ link.name }}
            </AppLink>
          </li>
        </ul>

        <a
          :href="`mailto:${ContactInfo.InfoEmailAddress}`"
          class="inline-flex gap-2 items-center sm:ml-auto hover:text-[#aac7e4]"
          target="_blank"
        >
          <FontAwesomeIcon
            size="lg"
            :icon="faEnvelope"
          />
          {{ ContactInfo.InfoEmailAddress }}
        </a>
      </div>

      <div class="inline-flex items-center gap-4">
        <AppLink
          :to="ContactInfo.InstagramHandle"
          class="hover:text-[#aac7e4]"
        >
          <span class="sr-only">Instagram</span>
          <FontAwesomeIcon
            size="xl"
            :icon="faInstagram"
          />
        </AppLink>

        <AppLink
          :to="ContactInfo.FacebookPage"
          class="hover:text-[#aac7e4]"
        >
          <span class="sr-only">Facebook</span>
          <FontAwesomeIcon
            size="xl"
            :icon="faFacebookSquare"
          />
        </AppLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import { AppDropdown, AppDropdownItem, AppLink } from '@/components/app';

import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { ContactInfo } from '@/const';
import { useAuthStore } from '@/store';

const authStore = useAuthStore();

const menuLinks = [
  { name: 'Privacy', to: { name: 'app_privacy_policy' } },
  { name: 'Terms of Use', to: { name: 'app_terms_of_use' } },
  { name: 'FAQs', to: { name: 'app_faqs' } },
];

</script>
